import { memo, forwardRef } from "react";
import type { SelectProps } from "../types";
import { colors, radius, spacing, transitions, typography } from "../tokens";

export const Select = memo(
  forwardRef<HTMLSelectElement, SelectProps>(function Select(
    { options, label, error, id, style, ...props },
    ref
  ) {
    const selectId = id ?? `select-${Math.random().toString(36).slice(2, 7)}`;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: spacing.xs }}>
        {label && (
          <label
            htmlFor={selectId}
            style={{
              fontFamily: typography.fontFamily,
              fontSize: typography.size.sm,
              fontWeight: typography.weight.medium,
              color: colors.textMuted,
            }}
          >
            {label}
          </label>
        )}
        <select
          ref={ref}
          id={selectId}
          aria-invalid={!!error}
          style={{
            background: colors.surface,
            border: `1.5px solid ${error ? colors.error : colors.surfaceBorder}`,
            borderRadius: radius.md,
            padding: `${spacing.sm} ${spacing.md}`,
            color: colors.text,
            fontFamily: typography.fontFamily,
            fontSize: typography.size.sm,
            fontWeight: typography.weight.semibold,
            cursor: "pointer",
            outline: "none",
            transition: `border-color ${transitions.fast}`,
            appearance: "none",
            ...style,
          }}
          {...props}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {error && (
          <span
            role="alert"
            style={{
              fontFamily: typography.fontFamily,
              fontSize: typography.size.xs,
              color: colors.error,
            }}
          >
            {error}
          </span>
        )}
      </div>
    );
  })
);
